import { __rest } from "tslib";
import * as React from 'react';
import { css } from '@patternfly/react-styles';
import styles from '@patternfly/react-styles/css/components/DataList/data-list';
export var DataListContext = React.createContext({
  isSelectable: false
});
export var DataList = function DataList(_a) {
  var _a$children = _a.children,
      children = _a$children === void 0 ? null : _a$children,
      _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      ariaLabel = _a['aria-label'],
      _a$selectedDataListIt = _a.selectedDataListItemId,
      selectedDataListItemId = _a$selectedDataListIt === void 0 ? '' : _a$selectedDataListIt,
      onSelectDataListItem = _a.onSelectDataListItem,
      _a$isCompact = _a.isCompact,
      isCompact = _a$isCompact === void 0 ? false : _a$isCompact,
      props = __rest(_a, ["children", "className", 'aria-label', "selectedDataListItemId", "onSelectDataListItem", "isCompact"]);

  var isSelectable = onSelectDataListItem !== undefined;

  var updateSelectedDataListItem = function updateSelectedDataListItem(id) {
    onSelectDataListItem(id);
  };

  return React.createElement(DataListContext.Provider, {
    value: {
      isSelectable: isSelectable,
      selectedDataListItemId: selectedDataListItemId,
      updateSelectedDataListItem: updateSelectedDataListItem
    }
  }, React.createElement("ul", Object.assign({
    className: css(styles.dataList, isCompact && styles.modifiers.compact, className),
    "aria-label": ariaLabel
  }, props), children));
};